import React from "react";
import commonTerms from "../../assets/img/commonTerms.png";
import {useTranslation} from "react-i18next";
import useTheme from "../../components/web/layoutscommon/DarkModeStorage";
import "../../css/web/UserPageRenew.css";

function UserTermsPg() {

    const {t} = useTranslation();
    const [theme] = useTheme();

    // 이용약관 1~21 조항
    const sections = Array.from({length: 21}, (_, i) => ({
        h: `ctpTuHd${i + 1}`,
        c: `ctpTuCont${i + 1}`,
    }));

    return (
        <div className="up-scope up-page" data-theme={theme}>
            <div className="up-doc-wrap">
                <div className="up-card">
                    <div className="up-doc-head">
                        <img className="up-invert" alt='' src={commonTerms}/>
                        <p className="t">{t('ctpTuHd')}</p>
                    </div>
                    <div className="up-doc-body">
                        {sections.map((s, i) => (
                            <div className={`up-doc-sec${i === 0 ? ' first' : ''}`} key={i}>
                                <h4>{t(s.h)}</h4>
                                <p>{t(s.c)}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UserTermsPg
